import { DateTime } from 'luxon';
import intersectionWith from 'lodash/intersectionWith';
import type { ICallDetails } from '../models/call-details.model';

export enum DepartureOrArrivalType {
  departure,
  arrival,
}

export class CallDetailsHelper {
  public static isDelayed(call: ICallDetails, departureOrArrival: DepartureOrArrivalType): boolean {
    if (departureOrArrival === DepartureOrArrivalType.departure) {
      if (call.plannedDepartureTime === undefined || call.estimatedDepartureTime === undefined) return false;
      return !!call.estimatedDepartureTime && DateTime.fromISO(call.estimatedDepartureTime) > DateTime.fromISO(call.plannedDepartureTime);
    }

    if (call.plannedArrivalTime === undefined || !(call.estimatedArrivalTime === undefined)) return false;
    return !!call.estimatedArrivalTime && DateTime.fromISO(call.estimatedArrivalTime) > DateTime.fromISO(call.plannedArrivalTime);
  }

  public static isOnTime(call: ICallDetails, departureOrArrival: DepartureOrArrivalType): boolean {
    if (departureOrArrival === DepartureOrArrivalType.departure) {
      if (call.plannedDepartureTime === undefined || call.estimatedDepartureTime === undefined) return true;
      return !call.estimatedDepartureTime || DateTime.fromISO(call.estimatedDepartureTime).equals(DateTime.fromISO(call.plannedDepartureTime));
    }

    if (call.plannedArrivalTime === undefined || call.estimatedArrivalTime === undefined) return true;
    return !call.estimatedArrivalTime || DateTime.fromISO(call.estimatedArrivalTime).equals(DateTime.fromISO(call.plannedArrivalTime));
  }

  public static getTime(call: ICallDetails, departureOrArrival: DepartureOrArrivalType, useEstimatedTime: boolean): string | undefined {
    if (departureOrArrival === DepartureOrArrivalType.departure) {
      if (useEstimatedTime) {
        return call.estimatedDepartureTime ? call.estimatedDepartureTime : call.plannedDepartureTime;
      }
      return call.plannedDepartureTime;
    }
    if (useEstimatedTime) {
      return call.estimatedArrivalTime ? call.estimatedArrivalTime : call.plannedArrivalTime;
    }
    return call.plannedArrivalTime;
  }

  public static getZoneDisplayName(call: ICallDetails): string {
    const abcZoneNumbers = [3000, 3001, 3002];

    if (!call || !call.tariffZones || call.tariffZones.length === 0) {
      return '';
    }

    return intersectionWith(call.tariffZones, abcZoneNumbers, (tz, n) => tz.number === n)
      .map((tz) => tz.shortName)
      .join(',');
  }
}
